import { createFileRoute } from '@tanstack/react-router'
import { BillingContainer } from '@/components/team/billing-container'
import { PanelsSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'

export const Route = createFileRoute('/o/$org/billing')({
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <PanelsSkeleton />
    </>
  ),
  component: BillingContainer,
})
